import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-search',
  templateUrl: './layout-search.component.html',
  styleUrls: ['./layout-search.component.scss']
})
export class LayoutSearchComponent {}
